import { calculatedDiscountTableTotalAmount } from 'modules/accommodations/features/reservations/helper';
import { TServiceTableData } from 'modules/accommodations/features/reservations/models';

export const transformedDiscountsForTable = (
  values: any,
  servicesTableData: TServiceTableData[],
) => {
  let serviceCurrencyISOValue = '';
  if (servicesTableData[0]) {
    serviceCurrencyISOValue = servicesTableData[0].serviceCurrencyISO;
  }

  return {
    id: null,
    rootId: 2, // predefined
    objectDefined: false,
    discountName: 'Discount/popust',
    reservationDiscountType: values.reservationDiscountType,
    amountPerDiscountType: values.amountPerDiscountType,
    serviceCurrencyISO: serviceCurrencyISOValue,
    totalAmount:
      values.applyDiscountPriceTo !== 10
        ? calculatedDiscountTableTotalAmount(
            servicesTableData,
            values.reservationDiscountType,
            values.amountPerDiscountType,
          )
        : 0,
    isDiscountVisible: true,
    applyDiscountPriceTo: values.applyDiscountPriceTo,
  };
};
